module.exports = __webpack_public_path__ + "img/step2.46458d09.png";